module.exports = __webpack_public_path__ + "static/img/pcmt_ts.a0c673d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pcmt_ts.jpg
// module id = FSqc
// module chunks = 1